<template>
  <div class="summary-container">
    <p class="title">{{ $t('汇总合计') }}:</p>
    <div class="item-price">
      <div>{{ dataInfo.documentTotal }}</div>
      <div class="item-label">{{ $t('单据合计') }}</div>
    </div>
    <div class="item-price">
      <div>{{ dataInfo.orderAmountSummary }}</div>
      <div class="item-label">{{ $t('COD订单金额汇总') }}</div>
    </div>
    <div class="item-price">
      <div>{{ dataInfo.customerFee }}</div>
      <div class="item-label">{{ $t('客户手续费汇总') }}</div>
    </div>
    <div class="item-price">
      <div>{{ dataInfo.amountPayable }}</div>
      <div class="item-label">{{ $t('应付客户金额汇总') }}</div>
    </div>
  </div>
</template>

<script>
import { fetchSummary } from '@/api/module/codRefund'
import { RESPONSE_SUCCESS } from '@/constants'

export default {
  name: 'TheSummary',
  props: ['params'],
  data() {
    return {
      dataInfo: {
        documentTotal: 0, // 单据合计
        orderAmountSummary: 0, // 应付客户金额汇总
        customerFee: 0, // 客户手续费汇总
        amountPayable: 0, // 应付客户金额汇总
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { data, code, msg } = await fetchSummary({
        timeType: 3,
        waybillNos: this.params.waybillIds,
        startTime: this.params.startDate, // 开始日期
        endTime: this.params.endDate, // 结束日期
      })
      if (code === RESPONSE_SUCCESS) {
        this.dataInfo = {
          documentTotal: data ? data.waybillNumSum : 0,
          orderAmountSummary: data ? data.collectionfeeSum : 0,
          customerFee: data ? data.customerFee : 0,
          amountPayable: data ? data.amountPayable : 0
        }
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-container {
  height: 150px;
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  background-color: #f7f7f7;
  border-radius: 12px;
  margin: 0 24px;

  .title {
    position: absolute;
    top: 8px;
    left: 10px;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }

  .item-price {
    font-size: 26px;
    color: #000000;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    min-width: 262px;
    flex: 1;

    .item-label {
      font-size: 20px;
      color: #333333;
      margin-top: 15px;
    }
  }
}
</style>
